import { render, staticRenderFns } from "./client-orders-history.vue?vue&type=template&id=bd2cfc3a&scoped=true&"
import script from "./client-orders-history.vue?vue&type=script&lang=js&"
export * from "./client-orders-history.vue?vue&type=script&lang=js&"
import style0 from "./client-orders-history.vue?vue&type=style&index=0&id=bd2cfc3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2cfc3a",
  null
  
)

export default component.exports